import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-yu-file',
  templateUrl: './yu-file.component.html',
  styleUrls: ['./yu-file.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class YuFileComponent {
  @Input() label: string = '';
  @Input() disabled: boolean = false;

  @Input() isIncorrectValue: boolean = false;
  @Input() helperText: string = '';
}
